var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F1F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9082 17L10.4551 14.3135H12.5195L11.9727 17H13.1416L13.6885 14.3135H15.4385L15.6572 13.1582H13.9209L14.3857 10.8682H16.0742L16.293 9.71973H14.625L15.1514 7.13574H13.9756L13.4492 9.71973H11.3848L11.9111 7.13574H10.7422L10.2227 9.71973H8.55469L8.32227 10.8682H9.9834L9.52539 13.1582H7.92578L7.7002 14.3135H9.28613L8.73926 17H9.9082ZM10.6465 13.1924L11.125 10.8408H13.2578L12.7793 13.1924H10.6465Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagIcon);
export default __webpack_public_path__ + "static/media/hashtag-icon.46698220b91521dda1c569c6d0b85ec1.svg";
export { ForwardRef as ReactComponent };